{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "HEADER": "Shopify",
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Скасувати",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Інтеграції",
    "DESCRIPTION": "Chatwoot integrates with multiple tools and services to improve your team's efficiency. Explore the list below to configure your favorite apps.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "SEARCH_PLACEHOLDER": "Search integrations...",
    "NO_RESULTS": "No integrations found matching your search",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Події з підпискою",
      "LEARN_MORE": "Learn more about webhooks",
      "SECRET": {
        "LABEL": "Secret",
        "COPY": "Copy secret to clipboard",
        "COPY_SUCCESS": "Secret copied to clipboard",
        "TOGGLE": "Toggle secret visibility",
        "CREATED_DESC": "Your webhook has been created. Use the secret below to verify webhook signatures. Please copy it now — you can also find it later in the webhook edit form.",
        "DONE": "Done"
      },
      "COUNT": "{n} webhook | {n} webhooks",
      "SEARCH_PLACEHOLDER": "Search webhooks...",
      "NO_RESULTS": "No webhooks found matching your search",
      "FORM": {
        "CANCEL": "Скасувати",
        "DESC": "Вебхуки автоматично повідомляють про те, що відбувається у вашому обліковому записі Chatwoot. Будь ласка, введіть дійсний URL для налаштування зворотного виклику.",
        "SUBSCRIPTIONS": {
          "LABEL": "Події",
          "EVENTS": {
            "CONVERSATION_CREATED": "Розмову створено",
            "CONVERSATION_STATUS_CHANGED": "Статус розмови змінено",
            "CONVERSATION_UPDATED": "Розмову оновлено",
            "MESSAGE_CREATED": "Повідомлення створено",
            "MESSAGE_UPDATED": "Повідомлення оновлено",
            "WEBWIDGET_TRIGGERED": "Віджет онлайн чату відкрий користувачем",
            "CONTACT_CREATED": "Контакт створено",
            "CONTACT_UPDATED": "Контакт оновлено",
            "CONVERSATION_TYPING_ON": "Conversation Typing On",
            "CONVERSATION_TYPING_OFF": "Conversation Typing Off",
            "INBOX_UPDATED": "Inbox updated"
          }
        },
        "NAME": {
          "LABEL": "Webhook Name",
          "PLACEHOLDER": "Enter the name of the webhook"
        },
        "END_POINT": {
          "LABEL": "URL вебхука",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Будь ласка, введіть правильний URL"
        },
        "EDIT_SUBMIT": "Оновити вебхук",
        "ADD_SUBMIT": "Створити вебхук"
      },
      "TITLE": "Веб-хук",
      "CONFIGURE": "Настроїти",
      "HEADER": "Налаштування вебхука",
      "HEADER_BTN_TXT": "Додати новий вебхук",
      "LOADING": "Отримання прикріплених вебхуків",
      "SEARCH_404": "Немає елементів, що відповідають запиту",
      "SIDEBAR_TXT": "<p><b>Вебхуки</b> </p> <p>Вебхуки - це виклики по HTTP, які можна налаштувати для кожного облікового запису. Вебхук виклики будуть відбуватися при подіях у Chatwoot, наприклад при нових зверненнях. Ви можете створити один чи кілька вебхуків. <br /><br /> Для створення <b>вебхука</b>, натисніть кнопку <b>Додати новий вебхук</b>. Ви тако можете видаляти вебхуки, натиснувши кнопку Видалити.</p>",
      "LIST": {
        "404": "Немає налаштованих вебхуків для цього облікового запису.",
        "TITLE": "Керування вебхуками",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Кінцева точка вебхука",
          "ACTIONS": "Дії"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Редагувати",
        "TITLE": "Редагувати вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Налаштування вебхуків успішно оновлено",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        }
      },
      "ADD": {
        "CANCEL": "Скасувати",
        "TITLE": "Додати новий вебхук",
        "API": {
          "SUCCESS_MESSAGE": "Налаштування вебхуків успішно додано",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Видалити",
        "API": {
          "SUCCESS_MESSAGE": "Вебхук успішно видалено",
          "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
        },
        "CONFIRM": {
          "TITLE": "Підтвердження видалення",
          "MESSAGE": "Ви впевнені, що хочете видалити webhook? ({webhookURL})",
          "YES": "Так, видалити ",
          "NO": "Ні, залиште"
        }
      }
    },
    "SLACK": {
      "HEADER": "Slack",
      "DELETE": "Видалити",
      "DELETE_CONFIRMATION": {
        "TITLE": "Видалити інтеграцію",
        "MESSAGE": "Ви впевнені, що бажаєте видалити інтеграцію? Виконання цього призведе до втрати доступу до розмов на робочому місці Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Використання Slack інтеграцію",
        "BODY": "With this integration, all of your incoming conversations will be synced to the ***{selectedChannelName}*** channel in your Slack workspace. You can manage all your customer conversations right within the channel and never miss a message.\n\nHere are the main features of the integration:\n\n**Respond to conversations from within Slack:** To respond to a conversation in the ***{selectedChannelName}*** Slack channel, simply type out your message and send it as a thread. This will create a response back to the customer through Chatwoot. It's that simple!\n\n **Create private notes:** If you want to create private notes instead of replies, start your message with ***`note:`***. This ensures that your message is kept private and won't be visible to the customer.\n\n**Associate an agent profile:** If the person who replied on Slack has an agent profile in Chatwoot under the same email, the replies will be associated with that agent profile automatically. This means you can easily track who said what and when. On the other hand, when the replier doesn't have an associated agent profile, the replies will appear from the bot profile to the customer.",
        "SELECTED": "вибрано"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Обрати канал",
        "UPDATE": "Оновити",
        "BUTTON_TEXT": "Підключити канал",
        "DESCRIPTION": "Ваш робочий простір Slack повністю пов'язаний з Chatwoot. Але інтеграція в даний час неактивна. Щоб активувати інтеграцію та підключити канал до Chatwoot, натисніть кнопку нижче.\n\n**Примітка:** Якщо ви намагаєтеся підключити приватний канал, додайте Chatwoot додаток до каналу Slack, перш ніж продовжити цей крок.",
        "ATTENTION_REQUIRED": "Потрібно звернути увагу",
        "EXPIRED": "Ваша інтеграція зі Slack закінчилася. Щоб продовжити отримувати повідомлення в Slack, будь ласка, видаліть інтеграцію і знову підключіть робочу область."
      },
      "UPDATE_ERROR": "Помилка при оновленні інтеграції, будь ласка, спробуйте ще раз",
      "UPDATE_SUCCESS": "Канал успішно підключено",
      "FAILED_TO_FETCH_CHANNELS": "Помилка при підключенні каналів з Slack, будь ласка, спробуйте ще раз"
    },
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Натисніть тут, щоб приєднатися",
      "LEAVE_THE_ROOM": "Залишити дзвінок",
      "START_VIDEO_CALL_HELP_TEXT": "Почати новий відеодзвінок із клієнтом",
      "JOIN_ERROR": "Помилка при підключенні до дзвінка. Будь ласка, спробуйте ще раз",
      "CREATE_ERROR": "Помилка при створенні посилання на зустріч, будь ласка, спробуйте знову"
    },
    "OPEN_AI": {
      "AI_ASSIST": "ШІ асистент",
      "WITH_AI": " {option} with AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Пропозиція для відповіді",
        "SUMMARIZE": "Підсумувати",
        "REPHRASE": "Покращити написання",
        "FIX_SPELLING_GRAMMAR": "Виправити правопис і граматику",
        "SHORTEN": "Скоротити",
        "EXPAND": "Розширити",
        "MAKE_FRIENDLY": "Змінити сигнал повідомлення на дружній",
        "MAKE_FORMAL": "Використовувати формальний сигнал",
        "SIMPLIFY": "Спростити",
        "CONFIDENT": "Use confident tone",
        "PROFESSIONAL": "Use professional tone",
        "CASUAL": "Use casual tone",
        "STRAIGHTFORWARD": "Use straightforward tone"
      },
      "REPLY_OPTIONS": {
        "IMPROVE_REPLY": "Improve reply",
        "IMPROVE_REPLY_SELECTION": "Improve the selection",
        "CHANGE_TONE": {
          "TITLE": "Change tone",
          "OPTIONS": {
            "PROFESSIONAL": "Професійний",
            "CASUAL": "Casual",
            "STRAIGHTFORWARD": "Straightforward",
            "CONFIDENT": "Confident",
            "FRIENDLY": "Дружній"
          }
        },
        "GRAMMAR": "Fix grammar & spelling",
        "SUGGESTION": "Suggest a reply",
        "SUMMARIZE": "Summarize the conversation",
        "ASK_COPILOT": "Ask Copilot"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Вміст чернетки",
        "GENERATED_TITLE": "Згенерований вміст",
        "AI_WRITING": "ШІ пише",
        "BUTTONS": {
          "APPLY": "Використати цю пропозицію",
          "CANCEL": "Скасувати"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Інтегрувати з OpenAI",
        "DESC": "Додайте розширені функції AI в панель керування за допомогою моделей GPT OpenAI. Для початку введіть ключ API з вашого облікового запису OpenAI.",
        "KEY_PLACEHOLDER": "Введіть ваш ключ OpenAI API",
        "BUTTONS": {
          "NEED_HELP": "Потрібна допомога?",
          "DISMISS": "Відхилити",
          "FINISH": "Завершити налаштування"
        },
        "DISMISS_MESSAGE": "Ви можете налаштувати інтеграцію OpenAI пізніше, коли забажаєте.",
        "SUCCESS_MESSAGE": "Інтеграція з OpenAI успішно налаштована"
      },
      "TITLE": "Покращити з ШІ",
      "SUMMARY_TITLE": "Резюме ШІ",
      "REPLY_TITLE": "Пропозиції відповіді від ШІ",
      "SUBTITLE": "Поліпшена відповідь буде згенерована за допомогою AI, основана на вашій чернетці.",
      "TONE": {
        "TITLE": "Тон",
        "OPTIONS": {
          "PROFESSIONAL": "Професійний",
          "FRIENDLY": "Дружній"
        }
      },
      "BUTTONS": {
        "GENERATE": "Згенерувати",
        "GENERATING": "Генерація...",
        "CANCEL": "Скасувати"
      },
      "GENERATE_ERROR": "Сталася помилка при обробці контенту, будь ласка, спробуйте ще раз"
    },
    "DELETE": {
      "BUTTON_TEXT": "Видалити",
      "API": {
        "SUCCESS_MESSAGE": "Інтеграція успішно видалена"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Підключитися"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Додатки для головного екрану",
      "HEADER_BTN_TXT": "Додати нову інформаційну панель",
      "SIDEBAR_TXT": "<p><b>Панель управління</b></p><p>Додатки дозволяють організаціям вставляти в панель керування Chatwoot інформацію, щоб надати контекст агентам підтримки клієнтів. Ця функція дозволяє створювати додаток незалежно і вставляти його в панелі управління відомості про користувача, їхні замовлення або історію попередніх платежів.</p><p>Коли ви вставляєте свій застосунок за допомогою панелі керування в Chatwoot, ваша програма отримає контекст розмови і зв'яжеться як віконна подія. Налаштуйте слухача для заходу повідомлення на вашій сторінці, щоб отримати контекст.</p><p>Щоб додати нову панель керування, натисніть кнопку 'Додати нову програму'.</p>",
      "DESCRIPTION": "Додатки дозволяють організаціям вбудовувати інформаційну панель керування і надавати контекст для агентів підтримки клієнтів. Ця функція дозволяє створювати додаток незалежно і додавати інформацію, що надавали про користувача, його замовлення або історію платежів.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "COUNT": "{n} dashboard app | {n} dashboard apps",
      "SEARCH_PLACEHOLDER": "Search dashboard apps...",
      "NO_RESULTS": "No dashboard apps found matching your search",
      "LIST": {
        "404": "Поки що немає налаштованих додатків в цьому акаунті",
        "LOADING": "Отримання додатків панелі керування...",
        "TABLE_HEADER": {
          "NAME": "Ім'я",
          "ENDPOINT": "Endpoint",
          "ACTIONS": "Дії"
        },
        "EDIT_TOOLTIP": "Редагувати додаток",
        "DELETE_TOOLTIP": "Видалити додаток"
      },
      "FORM": {
        "TITLE_LABEL": "Ім'я",
        "TITLE_PLACEHOLDER": "Введіть ім'я для вашої інформаційної панелі",
        "TITLE_ERROR": "Потрібно ім'я для головної панелі",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Введіть URL кінцевої точки, де розміщено ваш додаток",
        "URL_ERROR": "Потрібно вказати допустиму URL-адресу"
      },
      "CREATE": {
        "HEADER": "Додати нову інформаційну панель",
        "FORM_SUBMIT": "Додати",
        "FORM_CANCEL": "Скасувати",
        "API_SUCCESS": "Панель інструментів успішно налаштовано",
        "API_ERROR": "Не вдалося створити додаток. Будь ласка, спробуйте ще раз пізніше"
      },
      "UPDATE": {
        "HEADER": "Редагувати інформаційну панель",
        "FORM_SUBMIT": "Оновити",
        "FORM_CANCEL": "Скасувати",
        "API_SUCCESS": "Панель інструментів успішно оновлено",
        "API_ERROR": "Не вдалося оновити додаток. Будь ласка, спробуйте ще раз пізніше"
      },
      "DELETE": {
        "CONFIRM_YES": "Так, видалити це",
        "CONFIRM_NO": "Ні, зберегти це",
        "TITLE": "Підтвердіть видалення",
        "MESSAGE": "Ви дійсно бажаєте видалити програму - {appName}?",
        "API_SUCCESS": "Панель інструментів успішно видалено",
        "API_ERROR": "Не вдалося видалити додаток. Будь ласка, спробуйте ще раз пізніше"
      }
    },
    "LINEAR": {
      "HEADER": "Linear",
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Створити",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Лінк",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Назва",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Необхідно вказати назву"
          },
          "DESCRIPTION": {
            "LABEL": "Опис",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Команда",
            "PLACEHOLDER": "Виберіть команду",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Пріоритет",
            "PLACEHOLDER": "Оберіть пріоритет",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Мітка",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Статус",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Створити",
        "CANCEL": "Скасувати",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Статус",
        "PRIORITY": "Пріоритет",
        "ASSIGNEE": "Assignee",
        "LABELS": "Мітки",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "NO_LINKED_ISSUES": "No linked issues found",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Так, видалити",
        "CANCEL": "Скасувати"
      },
      "CTA": {
        "TITLE": "Connect to Linear",
        "AGENT_DESCRIPTION": "Linear workspace is not connected. Request your administrator to connect a workspace to use this integration.",
        "DESCRIPTION": "Linear workspace is not connected. Click the button below to connect your workspace to use this integration.",
        "BUTTON_TEXT": "Connect Linear workspace"
      }
    },
    "NOTION": {
      "HEADER": "Notion",
      "DELETE": {
        "TITLE": "Are you sure you want to delete the Notion integration?",
        "MESSAGE": "Deleting this integration will remove access to your Notion workspace and stop all related functionality.",
        "CONFIRM": "Так, видалити",
        "CANCEL": "Скасувати"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Дізнатися більше",
    "ASSISTANT_SWITCHER": {
      "ASSISTANTS": "Асистенти",
      "SWITCH_ASSISTANT": "Перемикання між асистентами",
      "NEW_ASSISTANT": "Створити асистента",
      "EMPTY_LIST": "Асистентів не знайдено, будь ласка, створіть одного, щоб почати"
    },
    "COPILOT": {
      "TITLE": "Copilot",
      "TRY_THESE_PROMPTS": "Try these prompts",
      "PANEL_TITLE": "Почніть працювати з Copilot",
      "KICK_OFF_MESSAGE": "Потрібен швидкий підсумок, хочете переглянути минулі розмови або скласти кращу відповідь? Copilot допоможе прискорити цей процес.",
      "SEND_MESSAGE": "Надіслати...",
      "EMPTY_MESSAGE": "Виникла помилка під час генерації відповіді. Будь ласка, спробуйте ще раз.",
      "LOADER": "Captain думає",
      "YOU": "Ви",
      "USE": "Використати це",
      "RESET": "Скинути",
      "SHOW_STEPS": "Показати кроки",
      "SELECT_ASSISTANT": "Вибрати асистента",
      "PROMPTS": {
        "SUMMARIZE": {
          "LABEL": "Підсумувати цю розмову",
          "CONTENT": "Підсумуйте ключові моменти, обговорені між клієнтом і агентом підтримки, включно з занепокоєннями клієнта, питаннями та наданими агентом рішеннями чи відповідями"
        },
        "SUGGEST": {
          "LABEL": "Запропонувати відповідь",
          "CONTENT": "Проаналізуйте питання клієнта і складіть відповідь, що ефективно вирішує їхні проблеми чи запитання. Відповідь має бути чіткою, лаконічною і містити корисну інформацію."
        },
        "RATE": {
          "LABEL": "Оцініть цю розмову",
          "CONTENT": "Перегляньте розмову, щоб оцінити, наскільки добре вона відповідає потребам клієнта. Поставте оцінку від 1 до 5, базуючись на тоні, ясності та ефективності."
        },
        "HIGH_PRIORITY": {
          "LABEL": "Розмови з високим пріоритетом",
          "CONTENT": "Дайте мені підсумок усіх відкритих розмов з високим пріоритетом. Включіть ID розмови, ім’я клієнта (якщо є), зміст останнього повідомлення та призначеного агента. Групуйте за статусом, якщо це доречно."
        },
        "LIST_CONTACTS": {
          "LABEL": "Список контактів",
          "CONTENT": "Покажіть список топ-10 контактів. Включіть ім’я, електронну пошту або номер телефону (якщо є), час останнього відвідування, теги (якщо є)."
        }
      }
    },
    "PLAYGROUND": {
      "USER": "Ви",
      "ASSISTANT": "Асистент",
      "MESSAGE_PLACEHOLDER": "Введіть Ваше повідомлення...",
      "HEADER": "Тестова зона",
      "DESCRIPTION": "Використовуйте цю тестову зону, щоб надсилати повідомлення своєму асистентові і перевіряти, чи відповідає він точно, швидко і в очікуваному тоні.",
      "CREDIT_NOTE": "Повідомлення, надіслані тут, зараховуються до ваших кредитів Captain."
    },
    "PAYWALL": {
      "TITLE": "Оновіть план для використання Captain AI",
      "AVAILABLE_ON": "Captain недоступний на безкоштовному плані.",
      "UPGRADE_PROMPT": "Оновіть план, щоб отримати доступ до наших асистентів, Copilot і не тільки.",
      "UPGRADE_NOW": "Оновити зараз",
      "CANCEL_ANYTIME": "Ви можете змінити або скасувати план у будь-який час"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI доступний тільки в планах Enterprise.",
      "UPGRADE_PROMPT": "Оновіть план, щоб отримати доступ до наших асистентів, Copilot і не тільки.",
      "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
    },
    "BANNER": {
      "RESPONSES": "Ви використали понад 80% ліміту відповідей. Щоб продовжити використовувати Captain AI, будь ласка, оновіть план.",
      "DOCUMENTS": "Досягнуто ліміту документів. Оновіть план, щоб продовжити використовувати Captain AI."
    },
    "FORM": {
      "CANCEL": "Скасувати",
      "CREATE": "Створити",
      "EDIT": "Оновити"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "NO_ASSISTANTS_AVAILABLE": "There are no assistants available in your account.",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "UPDATE": "Оновити",
        "SECTIONS": {
          "BASIC_INFO": "Basic Information",
          "SYSTEM_MESSAGES": "System Messages",
          "INSTRUCTIONS": "Instructions",
          "FEATURES": "Особливості",
          "TOOLS": "Tools "
        },
        "NAME": {
          "LABEL": "Ім'я",
          "PLACEHOLDER": "Enter assistant name",
          "ERROR": "The name is required"
        },
        "TEMPERATURE": {
          "LABEL": "Response Temperature",
          "DESCRIPTION": "Adjust how creative or restrictive the assistant's responses should be. Lower values produce more focused and deterministic responses, while higher values allow for more creative and varied outputs."
        },
        "DESCRIPTION": {
          "LABEL": "Опис",
          "PLACEHOLDER": "Enter assistant description",
          "ERROR": "The description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter product name",
          "ERROR": "The product name is required"
        },
        "WELCOME_MESSAGE": {
          "LABEL": "Welcome Message",
          "PLACEHOLDER": "Enter welcome message"
        },
        "HANDOFF_MESSAGE": {
          "LABEL": "Handoff Message",
          "PLACEHOLDER": "Enter handoff message"
        },
        "RESOLUTION_MESSAGE": {
          "LABEL": "Resolution Message",
          "PLACEHOLDER": "Enter resolution message"
        },
        "INSTRUCTIONS": {
          "LABEL": "Instructions",
          "PLACEHOLDER": "Enter instructions for the assistant"
        },
        "FEATURES": {
          "TITLE": "Особливості",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions.",
          "ALLOW_CITATIONS": "Include source citations in responses",
          "ALLOW_CONTACT_ATTRIBUTES": "Allow access to contact information"
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again.",
        "NOT_FOUND": "Could not find the assistant. Please try again."
      },
      "SETTINGS": {
        "HEADER": "Налаштування",
        "BASIC_SETTINGS": {
          "TITLE": "Basic settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "SYSTEM_SETTINGS": {
          "TITLE": "System settings",
          "DESCRIPTION": "Customize what the assistant says when ending a conversation or transferring to a human."
        },
        "CONTROL_ITEMS": {
          "TITLE": "The Fun Stuff",
          "DESCRIPTION": "Add more control to the assistant. (a bit more visual like a story : Query guardrail → scenarios → output) Nudges user to actually utilise these.",
          "OPTIONS": {
            "GUARDRAILS": {
              "TITLE": "Guardrails",
              "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic."
            },
            "RESPONSE_GUIDELINES": {
              "TITLE": "Response guidelines",
              "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?"
            }
          }
        },
        "DELETE": {
          "TITLE": "Delete Assistant",
          "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
          "BUTTON_TEXT": "Delete {assistantName}"
        }
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      },
      "GUARDRAILS": {
        "TITLE": "Guardrails",
        "DESCRIPTION": "Keeps things on track—only the kinds of questions you want your assistant to answer, nothing off-limits or off-topic.",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Видалити"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example guardrails",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another guardrail..."
          },
          "NEW": {
            "TITLE": "Add a guardrail",
            "CREATE": "Створити",
            "CANCEL": "Скасувати",
            "PLACEHOLDER": "Type in another guardrail...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Пошук..."
        },
        "EMPTY_MESSAGE": "No guardrails found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No guardrails found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Guardrails added successfully",
            "ERROR": "There was an error adding guardrails, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Guardrails updated successfully",
            "ERROR": "There was an error updating guardrails, please try again."
          },
          "DELETE": {
            "SUCCESS": "Guardrails deleted successfully",
            "ERROR": "There was an error deleting guardrails, please try again."
          }
        }
      },
      "RESPONSE_GUIDELINES": {
        "TITLE": "Response Guidelines",
        "DESCRIPTION": "The vibe and structure of your assistant’s replies—clear and friendly? Short and snappy? Detailed and formal?",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Видалити"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example response guidelines",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "SAVE": "Add and save (↵)",
            "PLACEHOLDER": "Type in another response guideline..."
          },
          "NEW": {
            "TITLE": "Add a response guideline",
            "CREATE": "Створити",
            "CANCEL": "Скасувати",
            "PLACEHOLDER": "Type in another response guideline...",
            "TEST_ALL": "Test all"
          }
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Пошук..."
        },
        "EMPTY_MESSAGE": "No response guidelines found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No response guidelines found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Response Guidelines added successfully",
            "ERROR": "There was an error adding response guidelines, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Response Guidelines updated successfully",
            "ERROR": "There was an error updating response guidelines, please try again."
          },
          "DELETE": {
            "SUCCESS": "Response Guidelines deleted successfully",
            "ERROR": "There was an error deleting response guidelines, please try again."
          }
        }
      },
      "SCENARIOS": {
        "TITLE": "Scenarios",
        "DESCRIPTION": "Give your assistant some context—like “what to do when a user is stuck,” or “how to act during a refund request.”",
        "BULK_ACTION": {
          "SELECTED": "{count} item selected | {count} items selected",
          "SELECT_ALL": "Select all ({count})",
          "UNSELECT_ALL": "Unselect all ({count})",
          "BULK_DELETE_BUTTON": "Видалити"
        },
        "ADD": {
          "SUGGESTED": {
            "TITLE": "Example scenarios",
            "ADD": "Add all",
            "ADD_SINGLE": "Add this",
            "TOOLS_USED": "Tools used :"
          },
          "NEW": {
            "CREATE": "Add a scenario",
            "TITLE": "Create a scenario",
            "FORM": {
              "TITLE": {
                "LABEL": "Назва",
                "PLACEHOLDER": "Enter a name for the scenario",
                "ERROR": "Scenario name is required"
              },
              "DESCRIPTION": {
                "LABEL": "Опис",
                "PLACEHOLDER": "Describe how and where this scenario will be used",
                "ERROR": "Scenario description is required"
              },
              "INSTRUCTION": {
                "LABEL": "How to handle",
                "PLACEHOLDER": "Describe how and where this scenario will be handled",
                "ERROR": "Scenario content is required"
              },
              "CREATE": "Створити",
              "CANCEL": "Скасувати"
            }
          }
        },
        "UPDATE": {
          "CANCEL": "Скасувати",
          "UPDATE": "Update changes"
        },
        "LIST": {
          "SEARCH_PLACEHOLDER": "Пошук..."
        },
        "EMPTY_MESSAGE": "No scenarios found. Create or add examples to begin.",
        "SEARCH_EMPTY_MESSAGE": "No scenarios found for this search.",
        "API": {
          "ADD": {
            "SUCCESS": "Scenarios added successfully",
            "ERROR": "There was an error adding scenarios, please try again."
          },
          "UPDATE": {
            "SUCCESS": "Scenarios updated successfully",
            "ERROR": "There was an error updating scenarios, please try again."
          },
          "DELETE": {
            "SUCCESS": "Scenarios deleted successfully",
            "ERROR": "There was an error deleting scenarios, please try again."
          }
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "BULK_DELETE_BUTTON": "Видалити",
      "BULK_SYNC_BUTTON": "Оновити",
      "BULK_DELETE": {
        "TITLE": "Delete documents?",
        "DESCRIPTION": "Are you sure you want to delete the selected documents? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "Documents deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the documents, please try again."
      },
      "BULK_SYNC": {
        "SUCCESS_MESSAGE_ONE": "Refresh queued for 1 document",
        "SUCCESS_MESSAGE": "Refresh queued for {count} documents",
        "ZERO_MESSAGE": "No documents marked for refresh.",
        "ERROR_MESSAGE": "There was an error queuing the refresh, please try again."
      },
      "SYNC": {
        "QUEUED_MESSAGE": "Refresh queued. We'll update the document shortly.",
        "ERROR_MESSAGE": "Could not queue refresh, please try again."
      },
      "FILTERS": {
        "SOURCE": {
          "ALL": "All sources",
          "WEB": "Web pages",
          "PDF": "PDFs"
        },
        "STATUS": {
          "ANY": "Any status",
          "UPDATED": "Updated",
          "NEEDS_UPDATE": "Needs update",
          "UPDATING": "Updating",
          "FAILED": "Failed"
        },
        "SORT": {
          "RECENTLY_UPDATED": "Recently updated",
          "RECENTLY_CREATED": "Recently created"
        },
        "SEARCH_PLACEHOLDER": "Search..."
      },
      "SYNC_STATUS": {
        "SYNCED": "last updated {time}",
        "SYNCING": "оновлення...",
        "STALE_SYNC": "update stalled",
        "FAILED": "Failed to sync",
        "NEVER_SYNCED": "not updated yet"
      },
      "SYNC_ERRORS": {
        "NOT_FOUND": "Сторінку не знайдено",
        "ACCESS_DENIED": "Access denied",
        "TIMEOUT": "Page took too long to respond",
        "CONTENT_EMPTY": "Page returned empty content",
        "FETCH_FAILED": "Could not fetch page",
        "SYNC_ERROR": "Unexpected error",
        "DEFAULT": "Sync error"
      },
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "TYPE": {
          "LABEL": "Document Type",
          "URL": "URL",
          "PDF": "PDF File"
        },
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "PDF_FILE": {
          "LABEL": "PDF File",
          "CHOOSE_FILE": "Choose PDF file",
          "ERROR": "Please select a PDF file",
          "HELP_TEXT": "Maximum file size: 10MB",
          "INVALID_TYPE": "Please select a valid PDF file",
          "TOO_LARGE": "File size exceeds 10MB limit"
        },
        "NAME": {
          "LABEL": "Document Name (Optional)",
          "PLACEHOLDER": "Enter a name for the document"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "SYNC_NOW": "Refresh now",
        "RETRY_SYNC": "Retry refresh",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FILTERED_TITLE": "No matching documents",
        "FILTERED_SUBTITLE": "Try changing the source, status, or search term.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "CUSTOM_TOOLS": {
      "HEADER": "Tools",
      "ADD_NEW": "Create a new tool",
      "SOFT_LIMIT_WARNING": "Having more than 10 tools may reduce the assistant's reliability in selecting the right tool. Consider removing unused tools for better results.",
      "EMPTY_STATE": {
        "TITLE": "No custom tools available",
        "SUBTITLE": "Create custom tools to connect your assistant with external APIs and services, enabling it to fetch data and perform actions on your behalf.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Custom Tools",
          "NOTE": "Custom tools allow your assistant to interact with external APIs and services. Create tools to fetch data, perform actions, or integrate with your existing systems to enhance your assistant's capabilities."
        }
      },
      "FORM_DESCRIPTION": "Configure your custom tool to connect with external APIs",
      "OPTIONS": {
        "EDIT_TOOL": "Edit tool",
        "DELETE_TOOL": "Delete tool"
      },
      "CREATE": {
        "TITLE": "Create Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool created successfully",
        "ERROR_MESSAGE": "Failed to create custom tool"
      },
      "EDIT": {
        "TITLE": "Edit Custom Tool",
        "SUCCESS_MESSAGE": "Custom tool updated successfully",
        "ERROR_MESSAGE": "Failed to update custom tool"
      },
      "DELETE": {
        "TITLE": "Delete Custom Tool",
        "DESCRIPTION": "Are you sure you want to delete this custom tool? This action cannot be undone.",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "Custom tool deleted successfully",
        "ERROR_MESSAGE": "Failed to delete custom tool"
      },
      "PAYWALL": {
        "TITLE": "Upgrade to use tools with Captain",
        "AVAILABLE_ON": "Captain Tools are only available in Business and Enterprise plans. Please upgrade to Business plan to use the feature.",
        "UPGRADE_PROMPT": "",
        "UPGRADE_NOW": "Відкрити рахунок",
        "CANCEL_ANYTIME": ""
      },
      "ENTERPRISE_PAYWALL": {
        "AVAILABLE_ON": "Captain Tools are only available in the paid plans.",
        "UPGRADE_PROMPT": "Please upgrade to a paid plan to use this feature.",
        "ASK_ADMIN": "Будь ласка, зверніться до адміністратора для оновлення."
      },
      "TEST": {
        "BUTTON": "Test connection",
        "SUCCESS": "Endpoint returned HTTP {status}",
        "ERROR": "Connection failed",
        "DISABLED_HINT": "Testing is only available for endpoints without templates or request bodies."
      },
      "FORM": {
        "TITLE": {
          "LABEL": "Tool Name",
          "PLACEHOLDER": "Order Lookup",
          "ERROR": "Tool name is required",
          "MAX_LENGTH_ERROR": "Tool name must be {max} characters or fewer"
        },
        "DESCRIPTION": {
          "LABEL": "Опис",
          "PLACEHOLDER": "Looks up order details by order ID"
        },
        "HTTP_METHOD": {
          "LABEL": "Method"
        },
        "ENDPOINT_URL": {
          "LABEL": "Endpoint URL",
          "PLACEHOLDER": "https://api.example.com/orders/{'{{'} order_id {'}}'}",
          "ERROR": "Valid URL is required"
        },
        "AUTH_TYPE": {
          "LABEL": "Authentication Type"
        },
        "AUTH_TYPES": {
          "NONE": "Нiчого",
          "BEARER": "Bearer Token",
          "BASIC": "Basic Auth",
          "API_KEY": "API ключ"
        },
        "AUTH_CONFIG": {
          "BEARER_TOKEN": "Bearer Token",
          "BEARER_TOKEN_PLACEHOLDER": "Enter your bearer token",
          "USERNAME": "Username",
          "USERNAME_PLACEHOLDER": "Enter username",
          "PASSWORD": "Пароль",
          "PASSWORD_PLACEHOLDER": "Enter password",
          "API_KEY": "Header Name",
          "API_KEY_PLACEHOLDER": "X-API-Key",
          "API_VALUE": "Header Value",
          "API_VALUE_PLACEHOLDER": "Enter API key value"
        },
        "PARAMETERS": {
          "LABEL": "Parameters",
          "HELP_TEXT": "Define the parameters that will be extracted from user queries"
        },
        "ADD_PARAMETER": "Add Parameter",
        "PARAM_NAME": {
          "PLACEHOLDER": "Parameter name (e.g., order_id)"
        },
        "PARAM_TYPE": {
          "PLACEHOLDER": "Тип"
        },
        "PARAM_TYPES": {
          "STRING": "String",
          "NUMBER": "Номер",
          "BOOLEAN": "Boolean",
          "ARRAY": "Array",
          "OBJECT": "Object"
        },
        "PARAM_DESCRIPTION": {
          "PLACEHOLDER": "Description of the parameter"
        },
        "PARAM_REQUIRED": {
          "LABEL": "Обов'язково"
        },
        "REQUEST_TEMPLATE": {
          "LABEL": "Request Body Template (Optional)",
          "PLACEHOLDER": "{'{'}\n  \"order_id\": \"{'{{'} order_id {'}}'}\"\n{'}'}"
        },
        "RESPONSE_TEMPLATE": {
          "LABEL": "Response Template (Optional)",
          "PLACEHOLDER": "Order {'{{'} order_id {'}}'} status: {'{{'} status {'}}'}"
        },
        "ERRORS": {
          "PARAM_NAME_REQUIRED": "Parameter name is required"
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "PENDING_FAQS": "Pending FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "SELECT_ALL": "Select all ({count})",
      "UNSELECT_ALL": "Unselect all ({count})",
      "SEARCH_PLACEHOLDER": "Search FAQs...",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Видалити",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Всі"
      },
      "STATUS": {
        "TITLE": "Статус",
        "PENDING": "Очікує",
        "APPROVED": "Approved",
        "ALL": "Всі"
      },
      "PENDING_BANNER": {
        "TITLE": "Captain has found some FAQs your customers were looking for.",
        "ACTION": "Click here to review"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Approve",
        "EDIT_RESPONSE": "Редагувати",
        "DELETE_RESPONSE": "Видалити"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "NO_PENDING_TITLE": "There are no more pending FAQs to review",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "CLEAR_SEARCH": "Clear active filters",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Від'єднатись"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Так, видалити",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Вхідні",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
